import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const processOptionsTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'Dialed DigitExtraction Server',
  key: 'dialedDigitExtractionServer',
  main: {
    metadata: {
      layout: {
        rows: [
          ['id'],
          ['PROCNAME', 'PARAMNAME', 'PARAMVALUE'],
          ['COMMENTS', '$empty', '$empty'],
          ['$empty', '$empty', '$empty'],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        initial: '123',
        hide: 'true',
      },
      PROCNAME: {
        label: 'Process Name',
        type: 'text',
        validation: {
          required: true,
          validators: [
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
            {
              type: 'length',
              length: 1302,
              errorMessage: 'Exceeds maximum length, 1302.  Please re-enter.',
            },
          ],
        },
      },
      PARAMNAME: {
        label: 'Parameter Name',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 1042,
              errorMessage: 'Exceeds maximum length, 1042.  Please re-enter.',
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        },
      },
      PARAMVALUE: {
        label: 'Parameter Value',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 1042,
              errorMessage: 'Exceeds maximum length, 1042.  Please re-enter.',
            },
          ],
        },
      },
      COMMENTS: {
        label: 'Comments',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 1042,
              errorMessage: 'Exceeds maximum length, 1042.  Please re-enter.',
            },
          ],
        },
      },
    },
  },
};
